<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 账号 -->
      <section slot="billId" slot-scope="prop">
        {{prop.form.billId}}
      </section>
      <!-- 账号 end -->
      <!-- 验证码 -->
      <section slot="captcha" slot-scope="prop">
        <el-input
          class="inputBox"
          v-model="prop.form.captcha"
          placeholder="请输入"
        >
          <article
            class="getCodeBtn"
            :class="{
              primary: !smsTime,
              cur: !smsTime,
              blur: smsTime,
            }"
            slot="suffix"
            @click="getSms"
          >
            {{smsTime || '获取短信验证码'}}
          </article>
        </el-input>
      </section>
      <!-- 验证码 end -->
    </qx-custom-form>
    <section class="tipBox">
      <el-alert
        :closable="false"
        title="温馨提示："
        type="warning" />
      <el-alert
        :closable="false"
        title="1.不能4位或以上连号数字（如123490或432190）。"
        type="warning" />
      <el-alert
        :closable="false"
        title="2.不能连续4位或以上相同（如111125）。"
        type="warning" />
      <el-alert
        :closable="false"
        title="3.不能与登录密码相同。"
        type="warning" />
    </section>
  </qx-card-form>
</template>

<script>
import {
  getSmsCode,
} from 'api';
import {
  mapState,
} from 'vuex';
export default {
  data () {
    return {
      smsTimer: null,
      smsTime: 0,
      baseForm: {
        stateOptions: [],
        orgIdOptions: [],
        form: [
          {
            label: '账号',
            value: 'billId',
            slot: true,
          },
          {
            label: '验证码',
            value: 'captcha',
            slot: true,
          },
          {
            label: '新密码',
            value: 'newPwd',
            type: 'input',
            placeholder: '请输入6位数字',
            attr: {
              type: 'password',
            },
          },
          {
            label: '确认密码',
            value: 'newPwdAgain',
            type: 'input',
            placeholder: '请输入确认密码',
            attr: {
              type: 'password',
            },
          },
        ],
        rules: {
          captcha: [ // 验证码
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
          newPwd: [ // 新密码
            { required: true, message: '请输入新密码', trigger: 'blur' },
          ],
          newPwdAgain: [ // 确认密码
            { required: true, message: '请输入确认密码', trigger: 'blur' },
            { validator: this.checkNewPwdAgain, trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    checkNewPwdAgain (rule, value, call) {
      const newPwd = this.$refs.baseForm.getVal('newPwd');
      const newPwdAgain = this.$refs.baseForm.getVal('newPwdAgain');
      if (newPwd !== newPwdAgain) {
        call('两次密码输入不一致');
      } else {
        call();
      }
    },
    async getSms () { // 获取短信验证码
      if (this.smsTime > 0) {
        return;
      }
      this.smsTime = 20;
      const formData = await this.handleSubData(true);
      const res = await getSmsCode({
        billId: formData.billId,
        codeType: 3,
      });
      if (!res.failed && res.info === 'Y') {
        this.$message.success('验证码已发送，请可留意查收');
        clearInterval(this.smsTimer);
        this.smsTimer = setInterval(() => {
          this.smsTime--;
          if (this.smsTime <= 0) {
            this.smsTime = 0;
            clearInterval(this.smsTimer);
          }
        }, 1000);
      } else if (!res.failed) {
        this.$message.error(res.errMesg);
        this.smsTime = 0;
      } else {
        this.smsTime = 0;
      }
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      // if (formData || cache) {
      // }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.captcha = this.encode(formData.captcha);
        formData.newPwd = this.encode(formData.newPwd);
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async init (data = {}) {
      data.billId = this.userInfo.staffTFInfo.loginAcct;
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.getCodeBtn{
  padding-right: 8px;
}
.tipBox{
  margin-top: 32px;
}
</style>
